import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {MAP_CONFIG} from '../../../utils/constants';
import Carousel from '../carousel/Carousel';
import CardPopularDestinations from './CardPopularDestinations';
import EdapViewTracker from '../../common/edap-view-tracker/EdapViewTracker';
import {AsyncMap as Map} from '../map/AsyncMap';

import './PopularDestinations.less';

const ACTIONLOCATION = 'destinations-component';

export function mapStateToProps({
    config: {isMobile},
    modules: {popularDestinations},
}) {
    return {
        isMobile,
        ...popularDestinations,
    };
}

export class PopularDestinationsComponent extends PureComponent {
    state = {
        highlightedItemLbsId: '',
        itemIndex: 1,
    };

    changeHighlightItem = (lbsId = '', index) => {
        this.setState((state) => ({
            highlightedItemLbsId: lbsId,
            itemIndex: index || state.itemIndex,
        }));
    };

    render() {
        const {itemIndex, highlightedItemLbsId} = this.state;
        const {destinations = [], isMobile, title} = this.props;

        const cardIndex = itemIndex > 6 ? 5 : itemIndex - 1;
        return (
            destinations.length >= 5 && (
                <section className="PopularDestinations section">
                    <div className="section--centered">
                        <h2 className="title">{title}</h2>
                        {!isMobile && (
                            <Map
                                {...{destinations, highlightedItemLbsId}}
                                changeHighlightItem={this.changeHighlightItem}
                                channel={MAP_CONFIG.channel}
                                apiKey={MAP_CONFIG.apiKey}
                            />
                        )}
                    </div>
                    <Carousel
                        cardIndex={cardIndex}
                        actionlocation={ACTIONLOCATION}
                    >
                        {destinations.map((destination, i) => (
                            <CardPopularDestinations
                                key={`${destination.simpleName}${i}`}
                                itemNumber={i + 1}
                                changeHighlightItem={this.changeHighlightItem}
                                highlightedItemLbsId={highlightedItemLbsId}
                                {...destination}
                            />
                        ))}
                    </Carousel>
                    <EdapViewTracker
                        eventData={{actionlocation: ACTIONLOCATION}}
                    />
                </section>
            )
        );
    }
}

export const PopularDestinations = connect(mapStateToProps)(
    PopularDestinationsComponent
);

PopularDestinations.displayName = 'PopularDestinations';

export default PopularDestinations;
